var map = {
	"./badung.png": 2080,
	"./bangli.png": 4745,
	"./buleleng.png": 1390,
	"./denpasar.png": 7128,
	"./gianyar.png": 4863,
	"./homepage.jpg": 8204,
	"./jembrana.png": 2482,
	"./karangasem.png": 1053,
	"./klungkung.png": 5406,
	"./tabanan.png": 5724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2594;